import * as React from "react";
import * as ReactDOM from "react-dom";
import { distanceInWords, differenceInCalendarDays, format } from "date-fns";
import * as ru from "date-fns/locale/ru";
import classnames from "classnames";
import Tooltip from "rc-tooltip";
import IHomework from "../../typings/IHomework";
import PrivateToggler from "../Homework/PrivateToggler";
import Status from "../Homework/Status";
import * as styles from "./styles.scss";

import {
  Card,
  Switch,
  List,
  Star,
  Input,
  Button,
  Form,
  Popup,
  Badge,
  Icon,
  Dropdown,
} from "../../components";
import { themeVariables } from "../../entryes/panel/MUI";
import { tl } from "../../utils";

interface IProps {
  title: string;
  homework: IHomework;
  imageDefault: boolean;
  image: string;
  courseName?: string;
  userFullname: string;
  userAvatar: string;
  userProfileUrl: string;
  onPrev?: any;
  onNext?: any;
  isCheck?: any;
}

interface IState {}

export class CardTitleHeader extends React.Component<IProps, IState> {
  public state = {};

  render() {
    const {
      title,
      courseName,
      imageDefault,
      image,
      onPrev,
      onNext,
      isCheck,
      userFullname,
      userAvatar,
      userProfileUrl,
    } = this.props;

    const className = {
      imageCourse: classnames({
        [styles.image]: true,
        [styles.imageDefault]: this.props.imageDefault,
      }),
    };

    return (
      <div className={styles.headerWrap}>
        {onPrev !== undefined ? (
          <div
            className={styles.navButton}
            onClick={onPrev}
            style={{
              backgroundColor: themeVariables.palette.default.main,
            }}
          >
            <Icon
              name="left"
              color={themeVariables.palette.primary.main}
              size={18}
            />
          </div>
        ) : null}
        <div
          className={styles.header}
          ref={(r) =>
            r
              ? r.getBoundingClientRect().height > 74
                ? (r.className += " lineClamp")
                : null
              : ""
          }
        >
          <div
            className={this.props.imageDefault ? " block__image_course" : ""}
          >
            <div
              className={className.imageCourse}
              style={
                !this.props.imageDefault
                  ? {
                      backgroundImage: `url(${image})`,
                    }
                  : null
              }
            />
          </div>
          <div className={styles.cardTitle}>
            <div className={styles.title} title={title}>
              {title}
            </div>
            {courseName &&
              <div className={styles.courseName} title={title}>
                {tl('Курс:')} {courseName}
              </div>
            }
          </div>
          <div className={styles.rightItems}>
            <div className={styles.rightTopItems}>
              <Status homework={this.props.homework} />
              <PrivateToggler homework={this.props.homework} />
            </div>
          </div>
        </div>
        {onNext !== undefined ? (
          <div
            className={styles.navButton}
            onClick={onNext}
            style={{
              backgroundColor: themeVariables.palette.default.main,
            }}
          >
            <Icon
              name="right"
              color={themeVariables.palette.primary.main}
              size={18}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
